<script>
export default {
  name: "settingsMeasureIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14.3132 12.6667V3.33334C14.3132 2.00001 13.6465 1.33334 12.3132 1.33334H9.64648C8.31315 1.33334 7.64648 2.00001 7.64648 3.33334V12.6667C7.64648 14 8.31315 14.6667 9.64648 14.6667H12.3132C13.6465 14.6667 14.3132 14 14.3132 12.6667Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
    />
    <path d="M7.64648 4H10.9798" stroke="#A2A5B9" stroke-linecap="round" />
    <path d="M7.64648 12H10.3132" stroke="#A2A5B9" stroke-linecap="round" />
    <path
      d="M7.64648 9.29999L10.9798 9.33332"
      stroke="#A2A5B9"
      stroke-linecap="round"
    />
    <path
      d="M7.64648 6.66666H9.64648"
      stroke="#A2A5B9"
      stroke-linecap="round"
    />
    <path
      d="M3.66083 1.33334C2.57417 1.33334 1.6875 2.22001 1.6875 3.30001V11.94C1.6875 12.24 1.81417 12.6933 1.9675 12.9533L2.51417 13.86C3.14083 14.9067 4.17417 14.9067 4.80083 13.86L5.3475 12.9533C5.50083 12.6933 5.6275 12.24 5.6275 11.94V3.30001C5.6275 2.22001 4.74083 1.33334 3.66083 1.33334Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
    />
    <path d="M5.6275 4.66666H1.6875" stroke="#A2A5B9" stroke-linecap="round" />
  </svg>
</template>

<style scoped></style>
